module.exports = __webpack_public_path__ + "img/full6-min.f2ca970c.png";